import React, { useEffect, useState } from 'react'
import OrderFulfillmentChart from '../chart/OrderFulfillmentChart';
import DataTable from 'react-data-table-component';
import Loader from "../loader/Loader";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import PurchaseOrderSummary from './PurchaseOrderSummary';
import AllPurchaseOrders from './AllPurchaseOrders';
import DispatchPlan from './DispatchPlan';
import DispatchPlancurrent from './DispatchPlancurrent';
export default function OrderReports() {
  const [loading, setLoading] = useState(false);
  return (
    <div className='container-fluid mt-3'>
      <PurchaseOrderSummary />
      <DispatchPlan />
      <DispatchPlancurrent />
    </div>
  )
}